import BaseReducer from './base.reducers'
let options = {};
options.resourceName='RelatedCase';
const RelatedCaseReducer = new BaseReducer(options);
export const RelatedCaseConfig = (state = {}, action) => RelatedCaseReducer.item(state, action);
